module.exports = __webpack_public_path__ + "static/img/before4.06479fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/before4.jpg
// module id = ksuo
// module chunks = 9